
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.2 50.7c2.1 4.5 4.6 8.9 7.9 12.6 1.2-2.2 2.1-4.5 3.1-6.8 3.9-10.2 6-21 7.4-31.7 1-8.1 1.7-16.4 1.6-24.5C52.9.5 43.4 2.9 35 7.1c-.2.1-.5.3-.7.5-.2 1.6 0 3.3-.1 4.9.3 13 2.6 26.2 8 38.2zM72.6 50.2c1.4 4.4 3 8.9 5.2 13 2.4-2.8 4.4-5.9 6.2-9.1 5.3-9.9 8.1-21.1 9.2-32.3.4-4.7.7-9.5.5-14.2-2.1-1.3-4.5-2.2-6.7-3.2-6.8-2.6-14-4-21.3-4.2-.1 4 .1 8 .4 11.9.9 12.9 2.7 25.7 6.5 38.1zM18.8 56.5c4.8-7.1 7.7-15.3 9.6-23.6C30.1 25.2 31 17.3 31 9.4c-.5.2-1 .5-1.4.8-8.1 5.2-15.1 12.2-20.2 20.5C1.9 42.8-1.3 57.7.5 71.8c7.5-3.1 13.8-8.7 18.3-15.3zM120.5 34.2c-4.5-8.6-11.1-16.2-19-21.9-1.5-1-2.9-2.1-4.5-2.9 0 6.3.6 12.7 1.7 19 1.7 9.5 4.7 19 9.9 27.1 4.5 7.1 11 13.1 18.9 16.3 1.6-12.8-.9-26.2-7-37.6zM44.8 74.9c-.4-.8-1.2-1.4-1.8-2.1-2.7-3.1-4.9-6.6-6.8-10.2-1.5-2.9-2.6-6-3.6-9-.6.9-.9 1.9-1.2 2.9-1.8 5.1-4.4 10-7.7 14.3C18.6 77.4 11.8 83 3.9 85.9c.1.6.3 1.2.5 1.7 2 5 4.6 9.8 7.8 14.1 1.3 1.6 2.5 3.4 4 4.8 1-.3 1.8-.9 2.7-1.4 9.6-6.2 17.2-15.2 23-24.9 1.1-1.7 2.2-3.4 2.9-5.3zM64.8 56.9c-.3-1.1-.2-2.3-.9-3.2-.7.9-.6 2.2-.9 3.2-2.1 10.8-5.3 21.5-9.6 31.6-4.9 11.4-11.3 22.4-20.3 31.1-.4.5.5.7.8.9 9 4.7 19.2 7.3 29.4 7.4 10.9.1 22-2.6 31.5-8-9-8.9-15.7-20-20.6-31.6-4-10.1-7.3-20.6-9.4-31.4zM96.5 56.4c-.3-.9-.5-1.9-1.1-2.7-.6 1-.9 2.2-1.3 3.3-2.4 6.5-6 12.5-10.7 17.6-.5.4-.1.9.1 1.3 2.1 4 4.5 7.8 7.1 11.4 5.1 6.9 11.2 13.2 18.5 18 .8.5 1.6 1.1 2.5 1.3.7-.5 1.2-1.3 1.7-1.9 3.4-4.1 6.2-8.6 8.5-13.4.8-1.7 1.6-3.5 2.1-5.3-4.3-1.6-8.2-3.9-11.7-6.8-7.2-6-12.6-14-15.7-22.8z"}})])
          )
        }
      }
    